import React from "react";
import { useFormContext, useFormState } from "react-hook-form";
import StatusSection from "@/features/alojamientos/components/sections/StatusSection";
import InfractionsSection from "@/components/form/sections/InfractionsSection";
import FormField from "@/components/form/FormField";
import { DateField } from "@/components/form/fields/DateField";
import { FileIcon, BuildingIcon } from "lucide-react";

interface LegalDataSectionProps {
  mode?: "create" | "edit" | "view";
}

const LegalDataSection = ({ mode }: LegalDataSectionProps) => {

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium flex items-center gap-2">
        <FileIcon size={18} />
        Registro
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <FormField
          name="establishmentName"
          label="Nombre del establecimiento"
          icon={BuildingIcon}
        />

        <FormField
          name="fileNumber"
          label="Número de legajo"
          icon={FileIcon}
        />

        <DateField 
          name="fileUpdatedDate"
          label="Fecha de actualización de Legajo"
        />
      </div>
      <StatusSection mode={mode} />
      <InfractionsSection />
    </div>
  );
};

export default LegalDataSection;
